import { createTheme, Theme } from '@mui/material/styles'
import { createBreakpoints } from '@mui/system'
import palette from './palette'
import font from './font'

const breakpoints = createBreakpoints({})

const {
  spacing,
  breakpoints: { up, down, values },
} = createTheme()

export const theme: Theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  palette,
  font,
  typography: {
    fontFamily: font.primary,
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          backgroundColor: palette.primary.dark,
          backgroundImage: 'none',
        },
      },
    },
    // start - стили модального окна
    MuiDialog: {
      styleOverrides: {
        paper: {
          width: '100%',
          background: '#222222',
          margin: 0,
          padding: '40px 0',
          borderRadius: 16,
          color: palette.text.primary,
        },
        paperFullScreen: {
          height: 'auto',
        },
        paperWidthMd: {
          maxWidth: '800px!important',
        },
        paperWidthSm: {
          maxWidth: '500px!important',
        },
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: {
          position: 'relative',
          backgroundColor: 'transparent',
          color: palette.error.main,
          textAlign: 'center',
          textTransform: 'uppercase',
          fontSize: 30,
          fontWeight: 700,
          fontFamily: font.secondary,
          display: 'flex',
          justifyContent: 'center',
          lineHeight: 1.2,
          [down('sm')]: {
            fontSize: 25,
            paddingLeft: 50,
            paddingRight: 50,
            lineHeight: 1.1,
          },
        },
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: {
          fontSize: 18,
          fontWeight: 500,
          paddingTop: 0,
          overflow: 'hidden',
          color: palette.text.secondary,
          '& ul': {
            textAlign: 'left',
            lineHeight: 1.4,
          },
          '& a': {
            color: palette.text.secondary,
            transition: '0.3s',
            '&:hover': {
              color: palette.text.primary,
            },
          },
          [down('sm')]: {
            fontSize: 15,
          },
        },
      },
    },
    // end - стили модального окна
    // start - стили таблицы
    MuiTableHead: {
      styleOverrides: {
        root: {
          fontSize: 18,
          '&>tr:nth-child(odd)': {
            backgroundColor: palette.secondary.main,
            borderRadius: 8,
            '&>th': {
              '&:first-child': {
                borderTopLeftRadius: 8,
              },
              '&:last-child': {
                borderTopRightRadius: 8,
              },
            },
          },
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          '&>tr:nth-last-child(1)': {
            '&>td': {
              borderBottom: `2px solid ${palette.secondary.main}`,
              [down('md')]: {
                borderBottom: 'none',
              },
            },
          },
          '&>tr:nth-child(even)': {
            backgroundColor: '#222222',
            borderRadius: 8,
            '&>td': {
              '&:first-child': {},
              '&:last-child': {},
              '& button': {
                '& span': {},
              },
              '& span': {},
            },
          },
          '& button': { '& span': {} },
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {},
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          lineHeight: 1.3,
          border: '0 none',
          textAlign: 'center',
        },
        head: {
          fontSize: 22,
          fontWeight: 700,
          padding: '15px 22px',
          minHeight: 50,
          color: palette.text.secondary,
          [down('md')]: {
            fontSize: 18,
          },
          [down('sm')]: {
            fontSize: 12,
            padding: '10px 10px',
            minHeight: 40,
          },
        },
        body: {
          fontSize: 16,
          fontWeight: 400,
          padding: '15px 22px',
          color: palette.text.secondary,
          [down('sm')]: {
            fontSize: 12,
            padding: '10px 10px',
          },
        },
      },
    },
    // end - стили таблицы
    // start - пагинация
    MuiPagination: {
      styleOverrides: {
        root: {},
      },
    },
    MuiPaginationItem: {
      styleOverrides: {
        root: {
          fontSize: 17,
          fontWeight: 500,
          color: `${palette.text.secondary}!important`,
          borderRadius: 0,
          [down('sm')]: {
            fontSize: 14,
            minWidth: 28,
          },
          '&.Mui-selected': {
            fontSize: 17,
            minWidth: 10,
            marginLeft: 10,
            marginRight: 10,
            color: `${palette.primary.contrastText}!important`,
            backgroundColor: 'transparent',
            borderBottom: '2px solid #E21222',
            [down('sm')]: {
              fontSize: 14,
              marginLeft: 5,
              marginRight: 5,
              position: 'relative',
              top: 1,
            },
            '&:hover': {
              color: `${palette.primary.contrastText}!important`,
              backgroundColor: 'transparent',
            },
          },
          '&:hover': {
            color: `${palette.primary.contrastText}!important`,
            backgroundColor: 'transparent',
          },
        },
        icon: {
          fill: '#E21222',
          fontSize: 25,
          [down('sm')]: {
            fontSize: 23,
          },
        },
      },
    },
    // end - пагинация
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: 10,
          marginLeft: 5,
          marginTop: 0,
          color: palette.error.main,
          [down('sm')]: {},
        },
      },
    },
    MuiSnackbarContent: {
      styleOverrides: {
        root: {
          flexWrap: 'nowrap',
          fontSize: 15,
          fontWeight: 500,
          borderRadius: 4,
          alignItems: 'center',
          lineHeight: 1.25,
          textAlign: 'center',
          boxShadow: 'none',
          backgroundImage: 'none',
          backgroundColor: 'rgba(226, 18, 34, 0.1)',
          '&.MuiPaper-root': {
            minWidth: 100,
          },
          [down('sm')]: {
            fontSize: 15,
          },
        },
        message: {
          flex: '0 0 100%',
          fontWeight: 400,
          padding: 0,
        },
        action: {},
      },
    },
    // start - стили табов
    MuiTabs: {
      styleOverrides: {
        root: {
          width: '100%',
          [down('sm')]: {
            minHeight: 40,
          },
        },
        indicator: {
          backgroundColor: 'transparent',
        },
        flexContainer: {
          justifyContent: 'center',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: 30,
          minWidth: 180,
          fontSize: 16,
          borderRadius: 30,
          textTransform: 'none',
          color: `${palette.primary.dark}!important`,
          backgroundColor: palette.text.secondary,
          fontWeight: 700,
          marginLeft: 7,
          marginRight: 7,
          transition: '0.2s',
          "&[aria-selected^='true']": {
            backgroundColor: palette.secondary.main,
            color: `${palette.text.secondary}!important`,
          },
          [down('sm')]: {
            fontSize: 14,
            minHeight: 25,
            minWidth: 150,
          },
        },
      },
    },
    // end - стили табов
    // start - стили аккордион
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: '#222222',
          marginBottom: 10,
          transition: '.3s',
          backgroundImage: 'none',
          '&.Mui-expanded': {
            marginBottom: '20px!important',
            boxShadow: 'none',
          },
          '&:before': {
            display: 'none',
          },
        },
        rounded: {
          borderRadius: 10,
          '&:last-child': {
            borderBottomLeftRadius: 10,
            borderBottomRightRadius: 10,
          },
          '&:first-child': {
            borderTopLeftRadius: 10,
            borderTopRightRadius: 10,
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          paddingLeft: 35,
          paddingRight: 25,
          minHeight: 45,
          [down('md')]: {
            paddingLeft: 30,
          },
          [down('sm')]: {
            paddingLeft: 20,
            minHeight: 40,
          },
        },
        content: {
          color: palette.text.secondary,
          fontWeight: 700,
          fontSize: 18,
          margin: '20px 0',
          [down('md')]: {
            fontSize: 17,
          },
          [down('sm')]: {
            fontSize: 15,
          },
        },
        expandIconWrapper: {
          borderRadius: '50%',
          color: palette.primary.dark,
          transition: '.2s',
          '& .MuiSvgIcon-root': {
            width: 40,
            height: 40,
          },
          '&:hover': {},
          '&$expanded': {},
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          fontSize: 16,
          lineHeight: 1.3,
          fontWeight: 300,
          color: palette.primary.contrastText,
          display: 'block',
          padding: '0 20px 20px',
          marginBottom: 0,
          borderBottomLeftRadius: 10,
          borderBottomRightRadius: 10,
          transition: '.3s',
          [down('sm')]: {
            fontSize: 14,
          },
          '& a': {},
        },
      },
    },
    // end - стили акккордион
    // start - стили поля ввода
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          fontSize: 17,
          minHeight: 40,
          '&.MuiIconButton-root': {
            color: palette.text.secondary,
          },
        },
        input: {},
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          fontFamily: font.primary,
          fontSize: 14,
          minHeight: 40,
          borderRadius: 30,
          paddingRight: 0,
          backgroundColor: '#141414',
          '& .MuiButtonBase-root': {
            color: `${palette.primary.contrastText}!important`,
          },
          [down('sm')]: {
            fontSize: 12,
            minHeight: 30,
          },
        },
        notchedOutline: {
          borderWidth: 2,
          borderStyle: 'solid',
          borderColor: palette.primary.contrastText,
        },
        input: {
          color: palette.primary.contrastText,
          fontWeight: 600,
          paddingTop: 9,
          paddingBottom: 9,
          [down('sm')]: {
            fontSize: 11,
            paddingTop: 10,
          },
          '&:-internal-autofill-selected': {
            background: 'transparent',
            '-webkit-box-shadow': 'inset 0 0 0 50px #ffffff!important',
            '-webkit-text-fill-color': '#000!important',
          },
          '&:-webkit-autofill': {
            background: 'transparent',
            '-webkit-box-shadow': 'inset 0 0 0 50px #ffffff!important',
            '-webkit-text-fill-color': '#000!important',
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          minHeight: 45,
          fontFamily: font.primary,
          backgroundColor: palette.primary.dark,
          color: palette.text.secondary,
          paddingRight: 5,
          '& svg': {
            color: '#6C6C6C',
          },
          '&:after': {
            display: 'none',
          },
          '&:before': {
            display: 'none',
          },
          '&:hover': {
            backgroundColor: palette.primary.dark,
          },
          '&.Mui-focused': {
            backgroundColor: palette.primary.dark,
          },
          '&.Mui-disabled': {
            backgroundColor: palette.primary.dark,
          },
        },
        input: {
          fontSize: 14,
          paddingTop: 9,
          fontWeight: 700,
          color: '#6C6C6C',
          '&:-internal-autofill-selected': {
            background: 'transparent',
            '-webkit-box-shadow': 'inset 0 0 0 50px #000000!important',
            '-webkit-text-fill-color': '#6C6C6C!important',
          },
          '&:-webkit-autofill': {
            background: 'transparent',
            '-webkit-box-shadow': 'inset 0 0 0 50px #000000!important',
            '-webkit-text-fill-color': '#6C6C6C!important',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontFamily: font.primary,
          fontSize: 14,
        },
        shrink: {
          fontSize: 10,
          transform: 'translate(13px, 0)',
        },
        filled: {
          color: '#6C6C6C',
          fontWeight: 700,
          transform: 'translate(13px, 60%)',
          '&.Mui-focused': {
            color: '#6C6C6C',
          },
          '&.MuiInputLabel-shrink': {
            fontSize: 12,
            transform: 'translate(5px, -105%)',
          },
        },
        outlined: {
          color: palette.primary.contrastText,
          fontWeight: 600,
          transform: 'translate(18px, 45%)',
          [down('sm')]: {
            fontSize: 11,
            transform: 'translate(13px, 65%)',
          },
          '&.Mui-focused': {
            color: palette.primary.contrastText,
          },
          '&.MuiInputLabel-shrink': {
            fontSize: 10,
            transform: 'translate(13px, -100%)',
            [down('sm')]: {
              fontSize: 9,
            },
          },
        },
      },
    },
    // end - стили поля ввода
    // start - стили поля со списком
    MuiSelect: {
      styleOverrides: {
        icon: {
          top: 15,
          right: 10,
          transition: '0.3s',
        },
        select: {
          [down('sm')]: {
            paddingRight: '24px!important',
          },
        },
      },
    },
    // end - стили поля со списком
    // start - стили кнопки
    MuiButtonBase: {
      styleOverrides: {
        root: {
          '& .MuiIconButton-root': {
            color: `${palette.primary.dark}!important`,
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        containedSecondary: {
          fontSize: 18,
          fontWeight: 700,
          borderRadius: 30,
          minWidth: 170,
          lineHeight: 1.2,
          minHeight: 50,
          padding: '15px 20px',
          transition: '.3s',
          textTransform: 'none',
          color: palette.text.secondary,
          [down('sm')]: {
            fontSize: 16,
            lineHeight: 1.2,
            minHeight: 45,
            padding: '10px 15px',
          },
          '&:hover': {
            color: palette.text.primary,
            transform: 'translate(0px, 1px)',
            backgroundColor: '#BB0A18',
          },
          '&.Mui-disabled': {
            opacity: '.8',
            color: `${palette.primary.dark}!important`,
            backgroundColor: `${palette.action.disabledBackground}!important`,
          },
        },
        containedError: {
          fontSize: 18,
          fontWeight: 700,
          borderRadius: 30,
          minWidth: 170,
          lineHeight: 1.2,
          minHeight: 50,
          padding: '20px 30px',
          transition: '.3s',
          textTransform: 'none',
          [down('lg')]: {
            fontSize: 17,
            minHeight: 50,
            padding: '18px 30px',
          },
          [down('md')]: {
            fontSize: 16,
            minHeight: 45,
            padding: '15px 25px',
          },
          [down('sm')]: {
            fontSize: 14,
            minHeight: 40,
            padding: '15px 20px',
          },
          '&:hover': {
            transform: 'translate(0px, 1px)',
          },
          '&.Mui-disabled': {
            opacity: '.8',
            color: `${palette.text.disabled}!important`,
            backgroundColor: `${palette.action.disabledBackground}!important`,
          },
        },
      },
    },
    // end - стили кнопки
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          '& .MuiTypography-root': {
            lineHeight: 1.4,
            fontSize: '13px!important',
            fontWeight: 700,
            color: '#CECECE',
            '& a': {
              color: '#CECECE!important',
              textDecoration: 'uppercase!important',
              transition: '0.2s',
              textDecorationColor: 'rgba(255, 255, 255, 0.8)!important',
              '&:hover': {
                color: `${palette.text.primary}!important`,
              },
            },
          },
        },
      },
    },
    MuiPopover: {
      styleOverrides: {
        root: {},
        paper: {
          fontSize: 13,
          fontWeight: 500,
          maxWidth: 300,
          lineHeight: 1.4,
          border: `1px solid #6C6C6C`,
          backgroundColor: '#222222',
          backgroundImage: 'none',
          color: palette.text.secondary,
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          background: '#EBEBEB',
          '&.MuiButtonBase-root-MuiMenuItem-root': {
            fontFamily: font.other,
            color: palette.secondary.dark,
          },
        },
      },
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontSize: '14px!important',
          fontWeight: 600,
          fontFamily: `${font.other}!important`,
          color: `${palette.primary.dark}!important`,
          transition: '0.1s',
          '&.Mui-selected': {
            backgroundColor: 'rgb(150, 150, 150)!important',
          },
          '&:hover': {
            backgroundColor: 'rgb(200, 200, 200)!important',
            [down('md')]: {
              backgroundColor: 'transparent!important',
            },
          },
          // '&:focus': {
          //   backgroundColor: 'transparent!important',
          //   '&:hover': {
          //     backgroundColor: '#BABABA!important',
          //   },
          // },
          [down('sm')]: {
            fontSize: '12px!important',
            minHeight: 35,
          },
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: palette.primary.dark,
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          backgroundColor: '#7BB7FF',
        },
        bar: {
          backgroundColor: palette.primary.dark,
        },
      },
    },
  },
})
